(function ($) {
  'use strict';

  var API  = 'https://shoptetapi.shopcode.cz/public/api.php';
  var KLIC = 'fb2978bc263cde095c6aaae887b50d00';
  var NEJVIC = 100;
  var GALERIE = 'shop';
  var V_DIVU = 10;        // kolik fotek se vloží do skrytého divu
  var LADENI = true;

  function kodProduktu($produkt) {
    var $el = $produkt.find('[data-micro="sku"]').first();
    var kod = $el.length ? $.trim($el.text()) : '';
    if (kod === '') {
      var $alt = $produkt.find('[data-micro-sku]').first();
      if ($alt.length) { kod = $.trim($alt.attr('data-micro-sku') || $alt.text()); }
    }
    return kod;
  }

  /*
   * Skrytý div s fotkami přímo v a.image. Vždy prvních V_DIVU fotek
   * v pořadí, v jakém je vrátilo API - hlavní první.
   *
   * loading="lazy" tu není kosmetika. Bez něj prohlížeč stáhne deset fotek
   * u každé karty na stránce hned, i když je div schovaný; s ním se stáhnou
   * až ve chvíli, kdy div někdo zobrazí.
   */
  function vlozSkrytyDiv($produkt, obrazky, nazev) {
    var $a = $produkt.find('a.image').first();

    if (!$a.length || !obrazky.length) { return null; }

    // Opakovaný běh (řazení, "načíst další") nesmí divy vrstvit.
    $a.children('.obrazky-skryte').remove();

    var $div = $('<div/>', {
      'class': 'obrazky-skryte',
      'aria-hidden': 'true'
    }).css('display', 'none');

    $.each(obrazky.slice(0, V_DIVU), function (poradi, obrazek) {
      if (!obrazek || !obrazek.url) { return; }

      var $img = $('<img/>', {
        src: obrazek.url,
        alt: obrazek.popis || nazev || '',
        loading: 'lazy',
        decoding: 'async'
      }).attr({
        'data-poradi': poradi,
        'data-hlavni': obrazek.hlavni ? '1' : '0',
        'data-galerie': obrazek.gallery || ''
      });

      $('<div/>', { 'class': 'img' }).append($img).appendTo($div);
    });

    if (!$div.children().length) { return null; }

    $a.append($div);

    return $div;
  }

  /*
   * .obrazky-skryte je display:none, dokud na kartu nikdo nenajede (o
   * zobrazení na hover se stará CSS). Slick proto nejde inicializovat
   * hned - na skrytém/nulově širokém prvku by si spočítal blbou šířku
   * (stejný problém jako u variant slideru). Init se zkusí až při
   * najetí myší, kdy uz je div reálně vidět a má šířku.
   *
   * Mezi najetími se div zase schová (display:none) a znovu zobrazí -
   * slick si po prvním initu šířku sám od sebe nepřepočítá, takže by si
   * při dalším najetí držel tu už neplatnou. Proto se při každém dalším
   * hoveru na už inicializovaný slider zavolá setPosition(), ať se
   * přeměří podle aktuální (teď zase viditelné) šířky.
   */
  function initGalerieNaHover($div) {
    if ($div.hasClass('slick-initialized')) {
      $div.slick('setPosition');
      return true;
    }
    if (!$div.is(':visible') || !$div.width()) { return false; }

    $div.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      fade: true,
      infinite: false
    });

    // .obrazky-skryte sedí uvnitř <a class="image"> - klik na šipky/tečky
    // by jinak propadl do odkazu a proklikl na detail produktu.
    $div.on('click', '.slick-arrow, .slick-dots', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    return true;
  }

  /*
   * Tohle je to místo, kde se rozhoduje, co se s fotkami stane. Všechno
   * ostatní je jen doprava dat.
   */
  function pouzijObrazky($produkt, produkt) {
    var obrazky = produkt.obrazky || [];

    $produkt.data('obrazky', obrazky);
    var $div = vlozSkrytyDiv($produkt, obrazky, produkt.nazev);

    if (!$div || $div.children().length < 2) { return; }

    $produkt.off('mouseenter.obrazkyGalerie')
      .on('mouseenter.obrazkyGalerie', function () {
        initGalerieNaHover($div);
      });
  }

  function nactiDavku(kody, mapa) {
    var dotaz = { klic: KLIC, obrazky: 1, rez: 'detail', strucne: 1, nejvic: 15, kody: kody.join(',') };
    if (GALERIE) { dotaz.galerie = GALERIE; }

    $.getJSON(API, dotaz)
      .done(function (data) {
        var produkty = (data && data.produkty) || [];

        if (LADENI) {
          console.log('obrazky: dotaz na', kody.length, 'kodu, vratilo se', produkty.length,
            data && data.chybejici && data.chybejici.length ? '| nezname: ' + data.chybejici.join(', ') : '');
        }

        $.each(produkty, function (_, produkt) {
          if (LADENI && !(produkt.obrazky || []).length) {
            console.log('obrazky: produkt', produkt.kod, 'nema v databazi zadnou fotku');
          }

          /*
           * Podle "kody", ne podle "kod": produkt s variantami má vlastní
           * kód prázdný (kód nesou až varianty), takže by se odpověď neměla
           * k čemu přiřadit. "kody" nese ty kódy z dotazu, které na tenhle
           * produkt ukazují - klidně víc najednou.
           */
          var kodyProduktu = (produkt.kody && produkt.kody.length)
            ? produkt.kody
            : (produkt.kod ? [produkt.kod] : []);

          $.each(kodyProduktu, function (_, kod) {
            $.each(mapa[kod] || [], function (_, $produkt) {
              pouzijObrazky($produkt, produkt);
            });
          });
        });
      })
      .fail(function (xhr) {
        // 404 = nenašel se ani jeden kód. Není to porucha, jen ty produkty
        // (zatím) nemáme. Cokoliv jiného stojí za pohled.
        var telo = xhr.responseJSON;
        console.warn('obrazky:', (telo && telo.chyba) || ('HTTP ' + xhr.status), telo && telo.chybejici);
      });
  }

  function doplnObrazky(kontejner) {
    var mapa = {};
    var karet = 0;

    $(kontejner || document).find('.product').each(function () {
      var $produkt = $(this);
      karet++;

      if ($produkt.data('obrazkyHotovo')) { return; }

      var kod = kodProduktu($produkt);
      if (!kod) { return; }

      $produkt.data('obrazkyHotovo', true);

      // Tentýž kód může být na stránce vícekrát. Ptáme se jednou, přiřadíme
      // všem kartám, které ho nesou.
      (mapa[kod] = mapa[kod] || []).push($produkt);
    });

    var kody = Object.keys(mapa);

    if (LADENI) {
      console.log('obrazky: karet .product =', karet, ', novych kodu =', kody.length);

      if (karet > 0 && kody.length === 0) {
        console.warn('obrazky: zadny kod. Bud uz jsou vsechny karty hotove, nebo '
          + 'selektor [data-micro="sku"] na teto sablone nesedi - zkus v konzoli: '
          + '$(\'.product\').first().find(\'[data-micro="sku"]\')');
      }
    }

    for (var i = 0; i < kody.length; i += NEJVIC) {
      nactiDavku(kody.slice(i, i + NEJVIC), mapa);
    }
  }

  $(function () { doplnObrazky(); });

  // Produkty dochází i ajaxem - řazení, stránkování, "načíst další".
  ['ShoptetDOMPageContentLoaded', 'ShoptetPageSortingChanged',
   'ShoptetDOMPageMoreProductsLoaded', 'ShoptetDOMContentLoaded'
  ].forEach(function (udalost) {
    document.addEventListener(udalost, function () { doplnObrazky(); });
  });

  window.shoptetObrazky = doplnObrazky;
})(jQuery);